// Global Instructions Rule Applied!
import dayjs from 'dayjs'
import { FILE_TYPE, URL_TYPE, DATE_FORMAT } from '../../../../state_manager/constants/files.ts'
import type { FileListItem } from '../../../services/filesService.ts'

export interface TransformedFileData {
  id: string
  type: typeof FILE_TYPE | typeof URL_TYPE
  name: string
  file_path: string
  url?: string
  uploadDate: string
}

/**
 * Translate backend list-item shape into the FileUploadManager internal
 * shape. The backend's `type` column is 'storage' | 'url'; the component
 * tree uses the historical FILE_TYPE='file' / URL_TYPE='url' constants.
 * Anything that isn't explicitly 'url' (including 'storage', 'file', or
 * legacy undefined) is treated as a file-type attachment.
 */
export const transformFileData = (file: FileListItem): TransformedFileData => {
  const isUrl = file.type === URL_TYPE
  const fileType = isUrl ? URL_TYPE : FILE_TYPE
  return {
    id: file.id,
    type: fileType,
    name: file.file_name,
    file_path: file.file_path,
    url: isUrl ? file.file_path : file.file_url,
    uploadDate:
      file.created_at || file.updated_at
        ? dayjs(file.created_at || file.updated_at).format(DATE_FORMAT)
        : ''
  }
}
